const mutations = {
  SET_PART(state, { part }) {
    state.part = part
  },
}
export default mutations
